import { OrderDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Grid } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { Dropdown } from '../../../../../../ui/components/pure/dropdown/dropdown.component';
import { TextField } from '../../../../../../ui/components/pure/text-field/text-field.component';
import { Colors } from '../../../../../../ui/theme/colors';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      '&::after': {
        content: '""',
        width: 'calc(100% + 48px)',
        height: '1px',
        backgroundColor: '#EBEDF2',
        margin: '0 -24px 8px -24px'
      }
    }
  })
);

export function DeliverNowModalRecipientSummary(props: { order: OrderDto }) {
  const classes = useStyles();
  return (
    <Grid container sx={{ flexDirection: 'column' }} className={classes.root}>
      <Grid style={{ marginBottom: '16px' }} size={12}>
        <Dropdown
          value={props.order.retailer.id}
          fullWidth
          textFieldDesktopWidth="100%"
          dropdownVariant="floating"
          forceShowLabel
          menuItems={[
            {
              value: props.order.retailer.id,
              label: props.order.retailer.name,
              imageURL: props.order.retailer.imageURL
            }
          ]}
          shrinkLabel={false}
          placeholder="Retailer"
          disabled
          slotProps={{
            input: {
              disableUnderline: true
            },
            select: {
              endAdornment: null,
              style: {
                color: Colors.darkGray,
                fontWeight: 600
              },
              IconComponent: () => null
            }
          }}
        />
      </Grid>
      <Grid style={{ marginBottom: '16px' }} size={12}>
        <TextField
          textFieldVariant="floating"
          placeholder="Customer"
          value={props.order.customer?.displayName ?? 'Unknown'}
          disabled
          slotProps={{
            input: {
              disableUnderline: true,
              style: {
                color: Colors.cellNonEditableGray
              }
            }
          }}
        />
      </Grid>
      <Grid style={{ marginBottom: '16px' }} size={12}>
        <TextField
          desktopWidth="100%"
          textFieldVariant="floating"
          placeholder="Retailer order number"
          value={props.order.orderNumber || '-'}
          disabled
          slotProps={{
            input: {
              disableUnderline: true,
              style: {
                color: Colors.cellNonEditableGray
              }
            }
          }}
        />
      </Grid>
    </Grid>
  );
}
